import BouncingIcon from "../../component/BouncingIcon";
import { MainContainer } from "../../component/container";
import { useNavigate } from 'react-router';
import about from '../../assets/video/ab.mp4'
import Mt from '../../assets/person/miaTm.jpg'
import KtT from '../../assets/person/Kt-tm.jpg'
import KsT from '../../assets/person/Ks-tm.jpg'
import KnT from '../../assets/person/kn-tm.jpg'
import { Element, Link } from 'react-scroll';

export default function About() {
    const navigate = useNavigate();

    return (
        <MainContainer>
            <div id='content' className="">

                <video className="w-screen h-screen  object-cover opacity-90" autoPlay playsInline loop muted>
                    <source src={about} type="video/mp4" />
                </video>

                <div className="w-full absolute top-1/2 left-0 transform -translate-y-1/2 2xl:px-80 xl:px-52 px-10">
                    <div className="bg-[#87ceeb] bg-opacity-70 p-4 rounded-full">
                        <h1 className="text-lg sm:text-4xl font-bold text-white text-center">About Us.</h1>

                    </div>
                </div>


                <Link to="Scroll" smooth={true} duration={500}>
                    <BouncingIcon />
                </Link>
            </div>
            <Element name="Scroll" className="element"><div className='min-h-[2px]'></div></Element>
            <div className="2xl:px-80 xl:px-52 px-10 mt-24">
                <div className="mt-32 grid md:grid-cols-2 grid-cols-1 gap-5 text-center">
                    <div>
                        <div className="font-bold text-xl text-[#2E51A9]">THE ACRFI in MIAMI, FLORIDA</div>
                        <div>The <span className="text-blue-400 hover:underline cursor-pointer" onClick={() => { navigate('/Location/Team') }}>Miami Team</span> is the Headquarter of the foundation, located in Miami, Florida.</div>
                        <img src={Mt} alt="Mt" className="w-full max-h-[412px] mt-5" />
                    </div>
                    <div>
                        <div className="font-bold text-xl text-[#2E51A9]">THE ACRFI in KATANGA / CONGO (DRC)</div>
                        <div>The Miami Team is the Headquarter of the foundation, located in Miami, Florida.</div>
                        <img src={KtT} alt="KtT" className="w-full max-h-[412px] mt-5" />
                    </div>
                    <div>
                        <div className="font-bold text-xl text-[#2E51A9]">THE ACRFI in KASAI / CONGO (DRC)</div>
                        <div>The ACRFI-KASAI</div>
                        <img src={KsT} alt="KsT" className="w-full max-h-[412px] mt-5" />
                    </div>
                    <div>
                        <div className="font-bold text-xl text-[#2E51A9]">THE ACRFI in KINSHASA  / CONGO (DRC)</div>
                        <div>The ACRFI-KINSHASA </div>
                        <img src={KnT} alt="KnT" className="w-full max-h-[412px] mt-5" />
                    </div>
                </div>
            </div>
        </MainContainer>
    )
}